var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"characteristic"},[_c('progress-bar',{attrs:{"size":"medium","bar-color":_vm.color,"val":_vm.progression,"bar-border-radius":10}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }